export interface Project {
  title: string;
  description: string;
  logo: string | null;
  logos?: string[];
  company: string | null;
  tags?: string[];
  route?: string | null;
  color?: string;
  cardClass?: string;
  video?: string;
  mediaOverlayImg?: string;
}

export const allProjects: Project[] = [
  {
    title: 'Getting an engineering first team to design with intention, not just optimization',
    description: 'Developed as part of the Mobility as a Social Service Project, Indiana University Indianapolis, 2025–2026. A year-long community-grounded research and service design capstone exploring how autonomous vehicles can expand access to food and social services in Indianapolis, funded by Public Interest Technology University Network (PIT-UN).',
    logo: '/content/toyota logo.png',
    logos: ['/content/toyota logo.png', '/content/ifdesign.png'],
    company: 'Toyota Mobility Foundation',
    tags: ['UX Research', 'Non-Profit', 'Community Planning', 'Social Impact', 'Apprenticeship', 'In Progress'],
    route: '/projects/tmf',
    color: '#FF4141',
    video: '/content/project card videos/tmf-card.mp4'
  },
  {
    title: 'A Trading App for People Who Have Outgrown the Simple Ones',
    description: 'Trading apps treat simple and serious as different products, so people end up running two. This one changes density instead of asking you to change apps, and ships as a prototype you can actually use.',
    logo: '/content/tothemoon-brand/tothemoon-logo.png',
    company: 'Self-directed concept',
    tags: ['Product Design', 'Interaction Design', 'Design Systems', 'Fintech', 'Prototype', 'Secondary Research'],
    route: '/projects/tothemoon',
    color: '#E4572E',
    video: '/content/project card videos/tothemoon-card.mp4',
  },
  {
    title: 'Redesigning the Offer-Discovery Experience Around Your Credit and Debit Cards',
    description: 'A design system case study proposing a new experience layer for MaxRewards, a card-linked offer aggregator. Cache reimagines the offer feed as a hand of cards, personalized by redemption behavior rather than static filters, backed by a machine-readable design-system.md built to scaffold UI through AI coding agents.',
    logo: '/content/cache/cache-logo.png',
    logos: ['/content/cache/cache-logo.png', '/content/cache/maxrewards-logo.svg'],
    company: 'Unsolicited redesign concept',
    tags: ['Design Systems', 'Product Design', 'Personalization', 'Agentic Workflows', 'Case Study'],
    route: '/projects/cache',
    color: '#00AE74',
    cardClass: 'cache-card',
    video: '/content/cache/Scene 1.mp4',
  },
  {
    title: 'Decoding Player Behavior: A Machine Learning Approach to NFL Big Data Bowl 2025',
    description: 'Leveraging data analytics and machine learning to predict player behavior patterns in the NFL Big Data Bowl 2025 competition. Using Python, R, and advanced statistical modeling to analyze tracking data, visualize player movements, and extract actionable insights from complex football datasets.',
    logo: '/content/nfl2.png',
    logos: ['/content/nfl2.png', '/content/nfl1.png'],
    company: null,
    tags: ['Data Visualization', 'Data Analytics', 'Sports Analytics', 'Behavior Prediction', 'Information Design'],
    route: '/projects/nfl',
    color: '#013369',
    video: '/content/project card videos/nfl-proj.mp4'
  },
  {
    title: 'Eliminating the Middleman: Connecting Indian Farmers Directly to Government Markets Through Digital Innovation',
    description: 'Secured first place in a National Level 12-hour UI/UX Designathon at Goa Engineering College. A comprehensive social impact project creating direct connections between farmers and government markets in India through user research, product design, and digital innovation.',
    logo: '/content/agrico1.png',
    logos: ['/content/agrico1.png'],
    company: null,
    tags: ['Product Design', 'National Designathon Winner', 'UX Research', 'Social Impact', 'Agriculture'],
    route: '/projects/agrico',
    color: '#35CB68',
    cardClass: 'agrico-card',
    video: '/content/project card videos/agrico-projectcard.mp4'
  },
  {
    title: 'Brand Identity & Product Modeling',
    description: 'A comprehensive branding project creating the visual identity, motion graphics, and 3D product modeling for CragTech\'s flagship rugged smartphone - the Matterhorn. Developed as part of Indiana University\'s brand design curriculum.',
    logo: '/content/cragtech/moodboard/logo1.svg',
    logos: ['/content/cragtech/moodboard/logo1.svg', '/content/iu-logo.webp'],
    company: 'CragTech',
    tags: ['Branding', 'Motion Graphics', '3D Design', 'Product Launch', 'Academic Project'],
    route: '/projects/cragtech',
    color: '#FFFFFF',
    video: '/content/project card videos/cragtech-final.mp4'
  },
  {
    title: 'Reimagining Urban Navigation: A Human-Centered Approach to Wayfinding in Downtown Indianapolis',
    description: 'A comprehensive UX research and design project focused on improving navigation and wayfinding experiences in downtown Indianapolis. Through ethnographic research, user interviews, and prototyping, we developed human-centered solutions to address urban navigation challenges.',
    logo: '/content/wayfinding1.png',
    logos: ['/content/wayfinding1.png', '/content/iu-logo.webp'],
    company: null,
    tags: ['UX Design', 'UX Research', 'Wayfinding', 'Urban Design', 'Academic Project'],
    route: '/projects/wayfinding',
    color: '#2E538D',
    cardClass: 'wayfinding-card',
    video: '/content/project card videos/traversorproject card video.mp4'
  },
  {
    title: 'Redesigning Microsoft Outlook as an agent-first email experience',
    description: 'A mobile app redesign that reimagines Outlook through an agentic lens — where an AI assistant surfaces what matters, resolves scheduling conflicts, contextualises junk, and drafts replies before you even open an email. From reactive inbox to proactive intelligence.',
    logo: null,
    logos: [
      '/content/outlookdes/Microsoft Outlook Icon 2025-present.svg',
      '/content/iu-logo.webp',
    ],
    company: 'Microsoft Outlook',
    tags: ['Mobile App Redesign', 'Agentic UX', 'Visual Design for UI', 'Academic Project'],
    route: '/projects/outlook',
    color: '#0078D4',
    cardClass: 'outlook-card',
    video: '/content/outlookdes/Scene-1.mp4',
  },
  // Cairn temporarily disabled — commented out rather than deleted so
  // it's a one-line uncomment to bring back (also disabled in App.tsx's
  // routes/imports).
  // {
  //   title: 'Designing voice assistants that listen the way a friend does',
  //   description: 'A case study on progressive intent narrowing — the unsolved problem of how voice assistants should handle users who change their minds mid-conversation. Grounded in research from Nielsen Norman Group, Amazon Science, and longitudinal Alexa field studies, Cairn proposes a lightweight contradiction-detection pattern that makes the invisible failure mode of voice UX visible.',
  //   logo: null,
  //   logos: ['/content/lumi/cairn-wordmark.svg', '/content/lumi/cairn-wordmark-dark.svg'],
  //   company: null,
  //   tags: ['Voice CUI', 'Interaction Design', 'Conversational AI', 'Design Research', 'Case Study'],
  //   route: '/projects/cairn',
  //   color: '#C9824E',
  //   cardClass: 'cairn-card',
  //   video: '/content/lumi/images/Scandinavian%20Armchair%20Video.mp4',
  // },
  {
    title: 'Building a Human Sensory Tracking App with AI: From Prompt to Product in 72 Hours',
    description: 'A speculative wellness app that maps your attentional and emotional state through behavioral signals, visualized as a living orb that morphs across five drift states. Built end-to-end using Figma Make, Claude, and a Vite + React + Tailwind v4 stack — entirely through AI-assisted development over a single FigBuild 2026 competition weekend.',
    logo: null,
    logos: ['/content/Drift/drift logo.svg', '/content/Drift/figbuild-logo.png'],
    video: '/content/Drift/driftcard.mp4',
    company: null,
    tags: ['Speculative Design', 'Vibe Coding', 'Visual Design', 'FigBuild 2026'],
    route: '/projects/drift',
    color: '#E8A020',
    cardClass: 'drift-card',
  },
];

// Featured projects (shown on home page): TMF first, then Cache
export const featuredProjects = [allProjects[0], allProjects[1]];
